import { render, staticRenderFns } from "./TaiNguyen.vue?vue&type=template&id=5388e954&scoped=true"
import script from "./TaiNguyen.vue?vue&type=script&lang=js"
export * from "./TaiNguyen.vue?vue&type=script&lang=js"
import style0 from "./TaiNguyen.vue?vue&type=style&index=0&id=5388e954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5388e954",
  null
  
)

export default component.exports